export default "__VITE_ASSET__G5nXD3cR__"